export default __webpack_public_path__ + "static/media/IMG-20210701-WA0030.a5845e73.jpg";